import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import {
  Heading,
  ListDisplay,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import {
  IPension,
  IBeneficiary,
  ETaxType,
  ETaxPlan
} from '@/modules/pension/types';
import { PensionAPI } from '@/modules/pension/services/pension';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivatePensionSection',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}

const pensionApi = new PensionAPI();



const isPensionInfoLoading = ref(false);
const hasPensionInfoError = ref(false);
const pensionInfo = ref<IPension | null>(null);

const beneficiariesList = computed(() => {
  const list: IBeneficiary[] = [];

  if (pensionInfo.value?.coverages) {
    pensionInfo.value.coverages.forEach(coverage => {
      coverage.beneficiaries.forEach(beneficiary => {
        list.push(beneficiary);
      });
    });
  }

  return list;
});

async function fetchPensionInfo() {
  isPensionInfoLoading.value = true;
  hasPensionInfoError.value = false;

  try {
    const customerId = WarrenSession.get(StorageKeys.CustomerId) as string;
    const data = await pensionApi.getPensionInfos(
      customerId,
      props.portfolioId
    );

    pensionInfo.value = data;
  } catch (e) {
    hasPensionInfoError.value = true;
  } finally {
    isPensionInfoLoading.value = false;
  }
}

function getTaxRule(taxType: number) {
  return ETaxType[taxType];
}

function getTaxPlan(taxPlan: number) {
  return ETaxPlan[taxPlan];
}

onMounted(async () => {
  await fetchPensionInfo();
});

return { __sfc: true,pensionApi, props, isPensionInfoLoading, hasPensionInfoError, pensionInfo, beneficiariesList, fetchPensionInfo, getTaxRule, getTaxPlan, Heading, ListDisplay, LoaderIndicator, HelperViewStatus }
}

})